export enum OutputType {
  Id = 'ID',
  Item = 'ITEM',
}
